<template>
  <div class="business-app">
    <header>
      <div class="header-wrap">
        <h1>
          <img src="../../assets/business/shared/soldoc_logo.png"
                 alt="soldoc">
        </h1>
        <span class="pipe"></span>
        <span class="brand">
          <img src="../../assets/business/shared/soldoc_business.png"
               alt="soldoc business">
        </span>
      </div>
    </header>

    <div id="content">
      <div class="content-wrap">
        <h1 class="content-title">누구나 쉽고 편한<br />의료 환경을 만듭니다</h1>

        <div class="card-group">
          <div
            v-for="card in businessCards"
            :key="'pc-' + card.id"
            class="business-card"
          >
            <a class="card-thumb" :href="card.href" target="_blank">
              <img :src="getImageSrc(card.imageName)" :alt="card.imageAlt">
            </a>
            <div class="card-info">
              <h1 class="card-title">
                <a :href="card.href" target="_blank">{{ card.title }}</a>
              </h1>
              <p class="card-description">{{ card.description }}</p>
              <ul class="card-labels">
                <li
                  v-for="(item, idx) in card.labels"
                  :key="idx"
                  :class="{ point: item.point }"
                >
                  {{ item.text }}
                </li>
              </ul>
              <a class="more" :href="card.href" target="_blank">
                바로가기
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34314 0.928931C8.95262 0.538407 8.31946 0.538407 7.92893 0.928931C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 8L8.74228e-08 9L15 9L15 8L15 7L-8.74228e-08 7L0 8Z" />
                </svg>
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>

    <footer>
      <div class="footer-wrap">
        <div class="fnb">
          <a href="https://soldoc.co.kr"
             target="_blank"
             title="새창으로 열림">솔닥소개</a>
          <span class="fnb-pipe">|</span>
          <a href="https://policy.soldoc.co.kr/terms"
             target="_blank"
             title="새창으로 열림">이용약관</a>
          <span class="fnb-pipe">|</span>
          <a href="https://policy.soldoc.co.kr/privacy"
             target="_blank"
             title="새창으로 열림">개인정보수집 및 이용 동의</a>
          <a href="https://soldoc.co.kr/partners"
             target="_blank"
             title="새창으로 열림">제휴신청</a>
          <span class="fnb-pipe">|</span>
          <a href="https://soldoc.co.kr/partners"
             target="_blank"
             title="새창으로 열림">B2B 제휴신청</a>
        </div>

        <p class="info">
          회사명 : 솔닥 주식회사&nbsp;&nbsp;|&nbsp;&nbsp;대표 : 김민승 이호익&nbsp;&nbsp;|사업자등록번호 : 284-87-00967&nbsp;&nbsp;|&nbsp;&nbsp;통신판매업신고번호 : 2021-서울강남-06329호<br />
          서울특별시 강남구 도산대로 174. 7층 (정안빌딩)&nbsp;&nbsp;|&nbsp;&nbsp;E-Mail : info@soldoc.co.kr&nbsp;&nbsp;|&nbsp;&nbsp;대표번호 : 02-6954-7676&nbsp;&nbsp;|&nbsp;&nbsp;개인정보관리자 : 김민승
          <br /><br />
          COPYRIGHT ⓒsoldoc.co.kr All rights reserved.
        </p>

        <div class="sns">
          <a href="https://www.instagram.com/dr.soldoc/" target="_blank"
             title="새 창 열림">
            <img src="../../assets/business/shared/ico_sns_insta.png"
                 alt="instagram"/>
          </a>
          <a href="https://blog.naver.com/soldoc_ac" target="_blank"
             title="새 창 열림">
            <img src="../../assets/business/shared/ico_sns_naver.png"
                 alt="blog"/>
          </a>
          <a href="https://www.youtube.com/channel/UCnXdyK6DZQ2sKvvlSonzXmA"
             target="_blank" title="새 창 열림">
            <img src="../../assets/business/shared/ico_sns_youtube.png"
                 alt="youtube"/>
          </a>
          <a href="http://pf.kakao.com/_xbzxhNxb" target="_blank"
             title="새 창 열림">
            <img src="../../assets/business/shared/ico_sns_kakao.png"
                 alt="kakao channel"/>
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import MobileBusinessCard
  from "../../components/business/MobileBusinessCard.vue";

export default {
  name: 'Business',
  components: {
    MobileBusinessCard
  },
  data() {
    return {
      windowWidth: 1280,
      businessCards: [
        {
          id: 1,
          title: '솔닥',
          label: '',
          labels: [
            {text: '보습제 MD'},
            {text: '탈모'},
            {text: '일반진료'}
          ],
          description: '대면 / 비대면진료 앱 서비스',
          imageName: 'banner_img_01.png',
          imageAlt: '대면 / 비대면진료 앱 서비스',
          href: 'https://soldoc.co.kr'
        },
        {
          id: 2,
          title: '솔닥 컨시어지',
          label: '1형 당뇨',
          labels: [
            {text: '1형 당뇨', point: true},
            {text: '연당기'},
            {text: '인슐린'}
          ],
          description: '1형 당뇨 맞춤 비대면진료 서비스',
          imageName: 'banner_img_02.png',
          imageAlt: '1형 당뇨 맞춤 비대면진료 서비스',
          href: 'https://concierge.soldoc.co.kr'
        },
        {
          id: 3,
          title: '바로돌봄',
          label: '',
          labels: [
            {text: '장기요양'},
            {text: '장애인'},
            {text: '섬벽지'}
          ],
          description: '의료취약계층을 위한 원격진료 솔루션',
          imageName: 'banner_img_03.png',
          imageAlt: '의료취약계층을 위한 원격진료 솔루션',
          href: 'https://barocare.soldoc.co.kr'
        },
        {
          id: 4,
          title: '솔닥 파트너스',
          label: '',
          labels: [
            {text: '1차의료기관'},
            {text: '의료진'},
          ],
          description: '의료진 전용 EMR / CRM 통합 솔루션',
          imageName: 'banner_img_04.png',
          imageAlt: '의료진 전용 EMR / CRM 통합 솔루션',
          href: 'https://soldoc.co.kr/partners'
        }
      ]
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 768
    }
  },
  mounted() {
    // this.windowWidth = window.innerWidth;
    // window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // handleResize() {
    //   this.windowWidth = window.innerWidth;
    // },
    getImageSrc(fileName) {
      const devicePath = this.isMobile ? 'mobile' : 'pc'
      return require(`@/assets/business/${devicePath}/${fileName}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/business/PcBusiness";
</style>



// WEBPACK FOOTER //
// src/page/business/PcBusiness.vue